import { render, staticRenderFns } from "./UsersUpdateSubmenu.vue?vue&type=template&id=e8ff30ba"
import script from "./UsersUpdateSubmenu.vue?vue&type=script&lang=js"
export * from "./UsersUpdateSubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports